<template>
   <form class="container ">
    <div class="d-flex justify-content-center">
        <h1 class="center title">Addblog</h1>
    </div>
        <div class="form-group mt-1">
            <label>Title</label>
            <input type="text" class="form-control" v-model="title" >
        </div>
        <div class="form-group">
            <label for="exampleInputPassword1">Description</label>
            <textarea type="text" class="form-control" v-model="description" ></textarea>
        </div>
        <div class="form-group">
            <label >Image</label>
            <input type="file" class="form-control" @change="onChangeFile" name="file" />
            <!-- <imageUrl v-model="file" />
            <input type="file" v-model="userInput" v-on:change="process()"> -->
        </div> 
         <div class="form-group">
            <label>URL</label>
            <input type="text" class="form-control" v-model="url" >
        </div>
        <div class="form-group">
            <label>URL (youtube)</label>
            <input type="text" class="form-control" v-model="urlY" >
        </div>
        <div class="form-group">
            <label >Slide Image</label>
            <input type="file" class="form-control" name="file" @change="handleFileChange" multiple />
            <!-- <input type="file" class="form-control" name="file" @change="handleFileChange($event,index)" multiple /> -->
        </div>        
        <button type="submit" class="btn btn-light me-2" @click.prevent="addBlog" >Enregistrer</button>
        <button type="button" class="btn btn-light" @click ="$emit('cancel' , {})" >Cancel</button>
        
    </form> 
</template>

<script>
import axios from "axios";
import APIs from "@/../config";
// const token = localStorage.getItem('access_token');
// if (token) {
//   axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
// }
export default {
// const axios = Axios.create({
//   baseURL: process.env.VUE_APP_API_URL}),
  // baseURL: 'http://localhost:3000',
  // headers: {
  //   Authorization: `Bearer ${localStorage.getItem('jwt')}`
  // }

  name: "addBlog",
  data() {
    return {
      title : "",
      description : "" , 
      url : "" , 
      urlY: "",
      selectedFile:"",
      selectedFiles: []
    }
  },

  methods:{
   addBlog(){
    let get_token = localStorage.getItem("token")
    let user_id = localStorage.getItem("user_id")

    let formData = new FormData();
      for(let i = 0; i < this.selectedFiles.length; i++) {
        console.log("sliderImg", this.selectedFiles[i])
        formData.append("sliderImg", this.selectedFiles[i]);
      }

      const youtubeUrl = this.urlY
      const videoIdPattern = /v=([a-zA-Z0-9_-]+)/;
      const match = youtubeUrl.match(videoIdPattern);

      if(this.urlY != '' && this.urlY != 'NONE') {
        if (match && match[1]) {
          const videoId = match[1];
          this.urlY = videoId
        } else {
          this.$swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'lien youtube invalide',
              showConfirmButton: false,
              timer: 1500
          })
        }
      }

      // formData.append("sliderImg", this.selectedFiles);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("url", this.url == "" ? "NONE" : this.url);
      formData.append("urlYoutube", this.urlY == "" ? "NONE" : this.urlY);
      // var get_token = localStorage.getItem('token')
      // var user_id = localStorage.getItem('user_id')
      axios.post(`${APIs.API_URL}/blog/${user_id}`, formData,{
        headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${get_token}`
        } 
      } )
      .then(() => {
              this.$swal.fire({
              position: 'top-end',
              icon: 'success',
              title: "ajoutée",
              showConfirmButton: false,
              timer: 1500
          });
          this.$emit("refresh")
      })
      .catch( (error) => {
        console.log(error)
          this.$swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.response.data.error,
              showConfirmButton: false,
              timer: 1500
          });
      });
    },
    onChangeFile(event) {
      this.selectedFiles.push(event.target.files[0])
    },

    handleFileChange(event) {
      for(let  i = 0 ; i < event.target.files.length ; i++)
        this.selectedFiles.push(event.target.files[i])
      // this.selectedFiles = event.target.files

      // console.log("all files", event.target.files.length)
      // console.log("one file", event.target.files[0])
    }
  },

};
</script>


<style lang="scss" scoped>
  .title{
    color:white;
  }
  .btn{
    color:white;
    background-color:#A68D5B;
    &:hover{
        color:white;
        background-color:#A68D5B;
    }
    }
</style>

